<div class="header-holder">

  <vmb-dark></vmb-dark>

  <button
    [matMenuTriggerFor]="menu"
    mat-icon-button aria-label="Menu button">
    <mat-icon>menu</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="['admin']">Admin</button>
    <button mat-menu-item (click)="configService.logout()">
      <mat-icon>logout</mat-icon>
      <span>Log out</span>
    </button>
  </mat-menu>
</div>